// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3-6go","footer":"ModalUpdate_footer__8Tse-"};